import OverlayTips from "../OverlayTips";

function LeaveTimeRequestPageOverlayTipsManager()
{
    PageOverlayTipsManager.call(this);
}

LeaveTimeRequestPageOverlayTipsManager.prototype = _.create(PageOverlayTipsManager.prototype, {

    addBaseTips: function()
    {
        PageOverlayTipsManager.prototype.addBaseTips.apply(this);
        
        // Sorting parameters
        this.add($("#tipLTRSorting"), {
            messageKey: "leave_time_requests.tips.sorting",
            direction: OverlayTips.DIRECTION_TOP_LEFT,
            offsetX: 5,
            offsetY: -10,
            outside: {
                direction: OverlayTips.DIRECTION_TOP_RIGHT,
                offsetX: 0,
                offsetY: 5
            }
        });

        this.add(
                function()
                {
                    var ret = $("#requestsTableContainer").find(".leaveType.has-comment .leaveTypeWithImg");
                    if (ret.length > 0)
                        ret = $(ret[ret.length >> 1]);
                    return ret;
                }, {
                    messageKey: "leave_time_requests.tips.leave_comment",
                    direction: OverlayTips.DIRECTION_TOP_RIGHT,
                    offsetX: 20,
                    offsetY: -5
                });

        function rejectCommentTip()
        {
            return $("#requestsTableContainer").find('td.status.rejected.has-comment .byWhom');
        }

        this.add(rejectCommentTip, {
            messageKey: "leave_time_requests.tips.reject_comment",
            direction: OverlayTips.DIRECTION_BOTTOM_LEFT,
            anchor: OverlayTips.DIRECTION_BOTTOM_RIGHT,
            offsetX: -5,
            offsetY: 5
        });

        this.add(function() { return $("#requestsTableContainer").find('.actualContent').find('.request:not(.notApprovable)').find("td.select input").eqOrLast(3)}, {
            messageKey: "leave_time_requests.tips.select_checkbox",
            direction: OverlayTips.DIRECTION_TOP_LEFT,
            offsetX: -5,
            offsetY: -5
        });
    }
});

export default LeaveTimeRequestPageOverlayTipsManager;


// WEBPACK FOOTER //
// ./web/actiplans/js/tips/managers/LeaveTimeRequestPageOverlayTipsManager.js